import React from 'react';

import { CareType } from '@pflegia/types/api/employer/care-type';
import { ReactComponent as AmbulantCare } from '@pflegia/ui/icons/ambulant-care.svg';
import { ReactComponent as DentalPractice } from '@pflegia/ui/icons/dental_practice.svg';
import { ReactComponent as DoctorOffice } from '@pflegia/ui/icons/doctor_office.svg';
import { ReactComponent as ElderlyCare } from '@pflegia/ui/icons/elderly-care-homes.svg';
import { ReactComponent as Hospitals } from '@pflegia/ui/icons/hospitals.svg';
import { ReactComponent as IntensiveCare } from '@pflegia/ui/icons/intensive-care.svg';
import { ReactComponent as Leasing } from '@pflegia/ui/icons/leasing.svg';
import { ReactComponent as Physiotherapy } from '@pflegia/ui/icons/physiotherapy.svg';

interface CareTypeIconProps {
  type: CareType;
  className?: string;
}

export const CareTypeIcon: React.FC<CareTypeIconProps> = ({ type, className }) => {
  const Icon = ICON_BY_CARE_TYPE[type] ?? Hospitals;

  return <Icon className={className} />;
};

const ICON_BY_CARE_TYPE: Record<CareType, typeof Hospitals> = {
  [CareType.Ambulant]: AmbulantCare,
  [CareType.DentalPractice]: DentalPractice,
  [CareType.DoctorOffice]: DoctorOffice,
  [CareType.Hospice]: ElderlyCare,
  [CareType.Hospital]: Hospitals,
  [CareType.IntensiveAmbulant]: AmbulantCare,
  [CareType.IntensiveStationary]: IntensiveCare,
  [CareType.Leasing]: Leasing,
  [CareType.Others]: Hospitals,
  [CareType.Physiotherapy]: Physiotherapy,
  [CareType.RehabClinic]: Hospitals,
  [CareType.Stationary]: ElderlyCare,
  [CareType.UniversityHospital]: Hospitals,
  [CareType.PrivateClinic]: Hospitals,
  [CareType.MedicalCareCenter]: DoctorOffice,
  [CareType.OutpatientPractice]: DoctorOffice,
};
